import { LeaderboardTable } from '../components/LeaderboardTable/LeaderboardTable';
import {
  LEADERBOARDS_TABLE_COLUMNS_CYCLING,
  LEADERBOARDS_TABLE_COLUMNS_OTHER,
  LEADERBOARDS_TABLE_COLUMNS_OVERALL,
  LEADERBOARDS_TABLE_COLUMNS_RUNNING,
  LEADERBOARDS_TABLE_COLUMNS_SWIMMING,
  LEADERBOARDS_TABLE_COLUMNS_WALKING,
} from '../constants/leaderboards';
import { Copy } from '../copy/Copy';
import { All } from '../icons/All/All';
import { Walk } from '../icons/Walk/Walk';
import { Run } from '../icons/Run/Run';
import { Cycle } from '../icons/Cycle/Cycle';
import { Swim } from '../icons/Swim/Swim';
import { Other } from '../icons/Other/Other';

export const mapLeaderboardTabs = (leaderboard) => [
  {
    icon: <All />,
    content: (
      <LeaderboardTable
        title={Copy.generate('Global.overall')}
        leaderboard={leaderboard.totalDistance}
        columns={LEADERBOARDS_TABLE_COLUMNS_OVERALL}
      />
    ),
  },
  {
    icon: <Walk />,
    content: (
      <LeaderboardTable
        title={Copy.generate('Global.walking')}
        leaderboard={leaderboard.totalWalking}
        columns={LEADERBOARDS_TABLE_COLUMNS_WALKING}
      />
    ),
  },
  {
    icon: <Run />,
    content: (
      <LeaderboardTable
        title={Copy.generate('Global.running')}
        leaderboard={leaderboard.totalRunning}
        columns={LEADERBOARDS_TABLE_COLUMNS_RUNNING}
      />
    ),
  },
  {
    icon: <Cycle />,
    content: (
      <LeaderboardTable
        title={Copy.generate('Global.cycling')}
        leaderboard={leaderboard.totalCycling}
        columns={LEADERBOARDS_TABLE_COLUMNS_CYCLING}
      />
    ),
  },
  {
    icon: <Swim />,
    content: (
      <LeaderboardTable
        title={Copy.generate('Global.swimming')}
        leaderboard={leaderboard.totalSwimming}
        columns={LEADERBOARDS_TABLE_COLUMNS_SWIMMING}
      />
    ),
  },
  {
    label: <Other />,
    content: (
      <LeaderboardTable
        title={Copy.generate('Global.other')}
        leaderboard={leaderboard.totalOther}
        columns={LEADERBOARDS_TABLE_COLUMNS_OTHER}
      />
    ),
  },
];
